import React, { PropTypes } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

const CheckboxGroup = (props, context) => {
  const {
    input,
    label,
    meta: { touched, error },
    checkboxes,
    groupClassName,
    id,
    disabled,
  } = props;
  const validationState = touched && !!error ? error.state : null;
  const validationMessageKey =
    !!error && error.messageKey ? error.messageKey : null;
  const validationValues = !!error && error.values ? error.values : null;
  const scene = context.scene ? "-" + context.scene : "";

  return (
    <FormGroup
      className={groupClassName}
      controlId={id + scene}
      validationState={validationState}
    >
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className="input-wrapper">
        {checkboxes.map((checkbox, index) => {
          return (
            <label key={index}>
              <input
                key={index}
                disabled={disabled || checkbox.disabled}
                type="checkbox"
                name={`${input.name}[${index}]`}
                id={`${input.name}[${index}]`}
                value={checkbox.value}
                checked={input.value.indexOf(checkbox.value) !== -1}
                onChange={(e) => {
                  const newValue = [...input.value];
                  if (e.target.checked) {
                    newValue.push(checkbox.value);
                  } else {
                    newValue.splice(newValue.indexOf(checkbox.value), 1);
                  }
                  return input.onChange(newValue);
                }}
              />
              <span className="checkbox-styler" />
              <span className="checkbox-text">{checkbox.text}</span>
            </label>
          );
        })}
        {touched && error && (
          <HelpBlock>
            <FormattedMessage
              id={validationMessageKey}
              values={validationValues}
            />
          </HelpBlock>
        )}
      </div>
    </FormGroup>
  );
};

CheckboxGroup.propTypes = {
  checkboxes: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  groupClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  meta: PropTypes.object.isRequired,
  validation: PropTypes.object,
};

export default CheckboxGroup;



// WEBPACK FOOTER //
// ./src/components/common/form/CheckboxGroup.js